import { render } from "./MeasuresKinds.vue?vue&type=template&id=1d44c27d&scoped=true"
import script from "./MeasuresKinds.vue?vue&type=script&lang=js"
export * from "./MeasuresKinds.vue?vue&type=script&lang=js"

import "./MeasuresKinds.vue?vue&type=style&index=0&id=1d44c27d&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d44c27d"]])

export default __exports__